import { Box, Button, Modal, Text } from '@rsos/components/capstone/base';
import {
  ModalFooter,
  ModalBody,
} from '@rsos/components/capstone/base/Modal/ModalComponents';

const RemoveAllEventsModal = ({ isOpened, onConfirm, onClose }) => {
  return (
    <Modal
      isOpened={isOpened}
      onClose={onClose}
      width={450}
      id="remove-all-events-modal"
      data-name="remove-all-events-modal"
    >
      <ModalBody onClose={onClose}>
        <Box gridRowGap="1rem">
          <Text size="header" color="primaryText">
            Clear All 911 Events?
          </Text>
          <Text size="normal" color="primaryText">
            All 911 events will be cleared, including any filtered or hidden
            calls.
          </Text>
        </Box>
      </ModalBody>
      <ModalFooter flow={12}>
        <Button
          btnType="tertiary"
          onClick={onClose}
          grow
          noMargin
          data-name="cancel-button"
        >
          Cancel
        </Button>
        <Button
          dataName="remove-all-button"
          btnType="warning_primary"
          onClick={onConfirm}
          grow
          noMargin
        >
          Remove All
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default RemoveAllEventsModal;
